import React from 'react'
import { CloseCircle, Edit2 } from 'iconsax-react'
import { useAppDispatch } from '@SonarCX/hooks/redux'
import { useTheme } from '@mui/material'

import { deleteInbox } from '@SonarCX/slices/baseInbox'
import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import { AddSuccessAlert } from '@SonarCX/slices/alert'
import useStyles from './styles'

type EditDeleteProps = {
  open: (data: APIBaseInbox) => () => void
  data: APIBaseInbox
}

const EditDelete: React.FC<EditDeleteProps> = ({ open, data }) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const { setAction, setReason, setSubtext, setTitle, setV2 } = useAreYouSure()

  const classes = useStyles()

  const handleDelete = React.useCallback(() => {
    setV2(true)
    setTitle('ARE YOU SURE?')
    setAction(() => {
      dispatch(
        deleteInbox(data.id, success => {
          if (success) {
            dispatch(AddSuccessAlert('Changes saved'))
          }
        })
      )
    })
    setReason(
      <span style={{ fontStyle: 'italic' }}>
        This will forever delete the inbox.
      </span>
    )
    setSubtext(
      <span style={{ fontStyle: 'italic', fontWeight: theme.bold.bold }}>
        You can only delete an inbox if no sessions are associated and it is not
        being currently used with an integration.
      </span>
    )
  }, [setTitle, setAction, setReason, setSubtext, setV2, dispatch, data, theme])

  return (
    <div>
      <Edit2 className={classes.icon} onClick={open(data)} />

      <CloseCircle className={classes.icon} onClick={handleDelete} />
    </div>
  )
}

export default EditDelete
